import React from 'react'
import Header from '../../components/Header'

const Confirmed = () => {
  return (
    <React.Fragment>
        <Header />
        <section className="signup-body">
            <section className="centered">
              <h1>Cuenta confirmada</h1>
              <h2>Espera a que uno de nuestros colaboradores revise tu cuenta. Recibiras un email cuando tu cuenta haya sido autorizada.</h2>
            </section>
        </section>
    </React.Fragment>
  )
}

export default Confirmed
